import styled from "styled-components";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { MainMenuMover } from "../components/MainMenuMover";
import Menu from "../components/menu/Menu";
import { motion } from "framer-motion";
import { PageTransition } from "../components/PageTransition";
import { SmoothScroll } from "../components/SmoothScroll";
import { ScrollContainerProvider } from "../context/ScrollContainerContext";
import { TimelineAnimateScrollProvider } from "../context/TimlineAnimateScrollContext";

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* pointer-events: all; */
`;

const HeaderLayout = styled.div`
  pointer-events: all;
`;

const MainSection = styled.main`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 0 auto;
`;

const FooterLayout = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: -1;
  pointer-events: all;
`;

const Content = styled.div`
  flex: 1;
  pointer-events: all;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const LayoutScroll: React.FC = ({ children }) => {
  return (
    <>
      <PageTransition>
        <ScrollContainerProvider>
          <TimelineAnimateScrollProvider>
            <SmoothScroll>
              <HeaderLayout>
                <Header />
              </HeaderLayout>
              <Wrapper>
                <MainSection>
                  <MainMenuMover>
                    <Content>{children}</Content>
                  </MainMenuMover>

                  <Menu />
                </MainSection>
                <FooterLayout>
                  <Footer isFull={true} />
                </FooterLayout>
              </Wrapper>
            </SmoothScroll>
          </TimelineAnimateScrollProvider>
        </ScrollContainerProvider>
      </PageTransition>
    </>
  );
};
